import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  AuthToken,
  AuthTokenService,
  Go,
  LocalStorageService
} from '@ui/legacy-lib';

@Component({
  selector: 'app-impersonate',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpersonateComponent {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthTokenService);
  private localStorage = inject(LocalStorageService);
  private store = inject(Store);

  constructor() {
    const { token, session_state, realm, baseUrl, clientId } =
      this.route.snapshot.queryParams;
    if (token) {
      this.authService.setToken({
        access_token: token,
        session_state
      } as AuthToken);

      this.localStorage.setItem('realm', realm);
      this.localStorage.setItem('clientId', clientId);
      this.localStorage.setItem('baseUrl', baseUrl);

      this.store.dispatch(new Go({ path: ['dashboard'] }));
    }
  }
}
